import React, { useState, useEffect } from 'react';
import API from '../../services/api';

const EditCustomerModal = ({ customer, onClose, onUpdated }) => {
    const [formData, setFormData] = useState({
        full_name: '', father_name: '', cnic: '', phone: '', address: '',
        monthly_income: '', occupation: '', ref_no: '', city_id: '', ref_id: '',
        // Guarantor 1
        g1_name: '', g1_father: '', g1_cnic: '', g1_phone: '', g1_address: '', g1_occupation: '',
        // Guarantor 2
        g2_name: '', g2_father: '', g2_cnic: '', g2_phone: '', g2_address: '', g2_occupation: ''
    });
    
    const [cnicFront, setCnicFront] = useState(null);
    const [cnicBack, setCnicBack] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (customer) {
            setFormData({
                full_name: customer.full_name || '',
                father_name: customer.father_name || '',
                cnic: customer.cnic || '',
                phone: customer.phone || '',
                address: customer.address || '',
                monthly_income: customer.monthly_income || '',
                occupation: customer.occupation || '',
                ref_no: customer.ref_no || '',
                city_id: customer.city_id || '',
                ref_id: customer.ref_id || '',
                // Guarantor 1
                g1_name: customer.g1_name || '',
                g1_father: customer.g1_father || '',
                g1_cnic: customer.g1_cnic || '',
                g1_phone: customer.g1_phone || '',
                g1_address: customer.g1_address || '',
                g1_occupation: customer.g1_occupation || '',
                // Guarantor 2
                g2_name: customer.g2_name || '',
                g2_father: customer.g2_father || '',
                g2_cnic: customer.g2_cnic || '',
                g2_phone: customer.g2_phone || '',
                g2_address: customer.g2_address || '',
                g2_occupation: customer.g2_occupation || ''
            });
        }
    }, [customer]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const data = new FormData();
        Object.keys(formData).forEach(key => {
            data.append(key, formData[key]);
        });

        if (cnicFront) data.append('cnic_front', cnicFront);
        if (cnicBack) data.append('cnic_back', cnicBack);

        try {
            const res = await API.put(`v1/customers/with-log/${customer.id}`, data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            if (res.data.success) {
                alert("Customer updated successfully & audit log maintained!");
                onUpdated();
                onClose();
            }
        } catch (err) {
            console.error(err);
            alert("Error updating customer: " + (err.response?.data?.error || err.message));
        } finally {
            setLoading(false);
        }
    };

    if (!customer) return null;

    return (
        <div style={styles.overlay} onClick={onClose}>
            <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div style={styles.header}>
                    <h3 style={{ margin: 0 }}>✏️ Edit Customer & Guarantors: {customer.full_name}</h3>
                    <button onClick={onClose} style={styles.closeBtn}>&times;</button>
                </div>
                <form onSubmit={handleSubmit} style={styles.form}>
                    
                    {/* Section 1: Personal Info */}
                    <h4 style={styles.sectionTitle}>👤 Personal Information</h4>
                    <div style={styles.grid}>
                        <div>
                            <label style={styles.label}>Full Name</label>
                            <input type="text" name="full_name" value={formData.full_name} onChange={handleChange} style={styles.input} required />
                        </div>
                        <div>
                            <label style={styles.label}>Father Name</label>
                            <input type="text" name="father_name" value={formData.father_name} onChange={handleChange} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>CNIC</label>
                            <input type="text" name="cnic" value={formData.cnic} onChange={handleChange} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>Phone</label>
                            <input type="text" name="phone" value={formData.phone} onChange={handleChange} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>Occupation</label>
                            <input type="text" name="occupation" value={formData.occupation} onChange={handleChange} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>Monthly Income</label>
                            <input type="number" name="monthly_income" value={formData.monthly_income} onChange={handleChange} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>File / Ref No</label>
                            <input type="text" name="ref_no" value={formData.ref_no} onChange={handleChange} style={styles.input} />
                        </div>
                        <div style={{ gridColumn: 'span 2' }}>
                            <label style={styles.label}>Address</label>
                            <input type="text" name="address" value={formData.address} onChange={handleChange} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>CNIC Front Image</label>
                            <input type="file" onChange={(e) => setCnicFront(e.target.files[0])} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>CNIC Back Image</label>
                            <input type="file" onChange={(e) => setCnicBack(e.target.files[0])} style={styles.input} />
                        </div>
                    </div>

                    {/* Section 2: Guarantor 1 */}
                    <h4 style={{...styles.sectionTitle, color: '#059669', marginTop: '20px'}}>🛡️ Guarantor 1 Information</h4>
                    <div style={styles.grid}>
                        <div>
                            <label style={styles.label}>G1 Name</label>
                            <input type="text" name="g1_name" value={formData.g1_name} onChange={handleChange} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>G1 Father Name</label>
                            <input type="text" name="g1_father" value={formData.g1_father} onChange={handleChange} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>G1 CNIC</label>
                            <input type="text" name="g1_cnic" value={formData.g1_cnic} onChange={handleChange} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>G1 Phone</label>
                            <input type="text" name="g1_phone" value={formData.g1_phone} onChange={handleChange} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>G1 Occupation</label>
                            <input type="text" name="g1_occupation" value={formData.g1_occupation} onChange={handleChange} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>G1 Address</label>
                            <input type="text" name="g1_address" value={formData.g1_address} onChange={handleChange} style={styles.input} />
                        </div>
                    </div>

                    {/* Section 3: Guarantor 2 */}
                    <h4 style={{...styles.sectionTitle, color: '#059669', marginTop: '20px'}}>🛡️ Guarantor 2 Information</h4>
                    <div style={styles.grid}>
                        <div>
                            <label style={styles.label}>G2 Name</label>
                            <input type="text" name="g2_name" value={formData.g2_name} onChange={handleChange} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>G2 Father Name</label>
                            <input type="text" name="g2_father" value={formData.g2_father} onChange={handleChange} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>G2 CNIC</label>
                            <input type="text" name="g2_cnic" value={formData.g2_cnic} onChange={handleChange} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>G2 Phone</label>
                            <input type="text" name="g2_phone" value={formData.g2_phone} onChange={handleChange} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>G2 Occupation</label>
                            <input type="text" name="g2_occupation" value={formData.g2_occupation} onChange={handleChange} style={styles.input} />
                        </div>
                        <div>
                            <label style={styles.label}>G2 Address</label>
                            <input type="text" name="g2_address" value={formData.g2_address} onChange={handleChange} style={styles.input} />
                        </div>
                    </div>

                    <div style={styles.btnContainer}>
                        <button type="button" onClick={onClose} style={styles.cancelBtn}>Cancel</button>
                        <button type="submit" style={styles.saveBtn} disabled={loading}>
                            {loading ? 'Updating...' : 'Update All Info'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

const styles = {
    overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10000 },
    modal: { background: '#fff', width: '900px', maxWidth: '95%', borderRadius: '10px', overflow: 'hidden', display: 'flex', flexDirection: 'column', maxHeight: '90vh' },
    header: { padding: '15px 20px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    closeBtn: { background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' },
    form: { padding: '20px', overflowY: 'auto', flex: 1 },
    sectionTitle: { fontSize: '15px', color: '#2563eb', marginBottom: '10px', borderBottom: '2px solid #e2e8f0', paddingBottom: '5px' },
    grid: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px', marginBottom: '15px' },
    label: { fontSize: '12px', color: '#475569', fontWeight: '500', display: 'block' },
    input: { width: '100%', padding: '7px', marginTop: '4px', borderRadius: '5px', border: '1px solid #cbd5e1', boxSizing: 'border-box', fontSize: '13px' },
    btnContainer: { marginTop: '20px', display: 'flex', justifyContent: 'flex-end', gap: '10px', borderTop: '1px solid #e2e8f0', paddingTop: '15px' },
    cancelBtn: { padding: '10px 20px', background: '#e2e8f0', color: '#475569', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: '500' },
    saveBtn: { padding: '10px 20px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: '500' }
};

export default EditCustomerModal;